export const DMP_ROOT_VALUE = process.env.REACT_APP_DMP_ROOT_VALUE;
